<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Lincoln Kate’s longest love has always been language. She is an experience thief with the aim to enjoy life by understanding it. When not in the sun or between pages, she can be found teaching teens or stealing stories.</p><br/>
<p style="text-indent:0em;">Cover art: Daniel Bennett</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?c3a110f6